import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "org-contact-info" }
const _hoisted_2 = { class: "org-contact-info__card-header" }
const _hoisted_3 = { class: "org-contact-info__card-title" }
const _hoisted_4 = { class: "org-contact-info__card-body" }
const _hoisted_5 = { class: "org-contact-info__item" }
const _hoisted_6 = { class: "org-contact-info__text" }
const _hoisted_7 = { class: "org-contact-info__item" }
const _hoisted_8 = ["href"]
const _hoisted_9 = { class: "org-contact-info__item" }
const _hoisted_10 = ["href"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_iconMail = _resolveComponent("iconMail")!
  const _component_iconContact = _resolveComponent("iconContact")!
  const _component_hadrianModal = _resolveComponent("hadrianModal")!

  return (_openBlock(), _createBlock(_component_hadrianModal, {
    ref: "organizationContactInfoModal",
    leftButtonText: _ctx.$t('generic.cancel'),
    onLeftButtonClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.cancel())),
    hideOnLeftClick: true,
    hideRightButton: true,
    hideHeader: true,
    variant: _ctx.ModalVariant.Thin
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.contactSections, (contact) => {
          return (_openBlock(), _createElementBlock("div", {
            class: "org-contact-info__card",
            key: contact.title
          }, [
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(contact.title), 1)
            ]),
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                (_openBlock(), _createBlock(_resolveDynamicComponent(contact.icon), { class: "org-contact-info__icon" })),
                _createElementVNode("span", _hoisted_6, _toDisplayString(contact.name || _ctx.$t('generic.na')), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createVNode(_component_iconMail, { class: "org-contact-info__icon" }),
                _createElementVNode("a", {
                  href: contact.email ? `mailto:${contact.email}` : undefined,
                  class: "org-contact-info__link"
                }, _toDisplayString(contact.email || _ctx.$t('generic.na')), 9, _hoisted_8)
              ]),
              _createElementVNode("div", _hoisted_9, [
                _createVNode(_component_iconContact, { class: "org-contact-info__icon" }),
                _createElementVNode("a", {
                  href: contact.phone ? `tel:${contact.phone}` : undefined,
                  class: "org-contact-info__link"
                }, _toDisplayString(contact.phone || _ctx.$t('generic.na')), 9, _hoisted_10)
              ])
            ])
          ]))
        }), 128))
      ])
    ], undefined, true),
    _: 1
  }, 8, ["leftButtonText", "variant"]))
}